import React from "react";
import ReactApexChart from "react-apexcharts";

const WebsiteAnalyticsChart = ({ chartData }) => {
    const labels = chartData.days ? chartData.days.map(day => day.day).reverse() : [];
    const androidLeadData = chartData.androidLeadData ? [...chartData.androidLeadData].reverse() : [];
    const androidAddToCartData = chartData.androidAddToCartData ? [...chartData.androidAddToCartData].reverse() : [];
    const androidPurchaseData = chartData.androidPurchaseData ? [...chartData.androidPurchaseData].reverse() : [];
    const iOSLeadData = chartData.iOSLeadData ? [...chartData.iOSLeadData].reverse() : [];
    const iOSAddToCartData = chartData.iOSAddToCartData ? [...chartData.iOSAddToCartData].reverse() : [];
    const iOSPurchaseData = chartData.iOSPurchaseData ? [...chartData.iOSPurchaseData].reverse() : [];

    const series = [
        {
            name: "Android Leads",
            type: "column",
            data: androidLeadData || [],
        },
        {
            name: "Android Add to Cart",
            type: "line",
            data: androidAddToCartData || [],
        },
        {
            name: "Android Purchases",
            type: "line",
            data: androidPurchaseData || [],
        },
        {
            name: "iOS Leads",
            type: "column",
            data: iOSLeadData || [],
        },
        {
            name: "iOS Add to Cart",
            type: "line",
            data: iOSAddToCartData || [],
        },
        {
            name: "iOS Purchases",
            type: "line",
            data: iOSPurchaseData || [],
        }
    ];

    const options = {
        chart: {
            toolbar: {
                show: false,
            },
        },
        stroke: {
            width: [0, 3, 3, 0, 3, 3],
            curve: "smooth",
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "20%",
            },
        },
        dataLabels: {
            enabled: false,
        },
        legend: {
            show: false,
            labels: {
                useSeriesColors: true, 
            },
        },
        colors : [
            "#0D47A1",
            "#1976D2",
            "#42A5F5",
            "#1cbb8c",
            "#26A69A",
            "#80CBC4",
        ],        
        labels: labels, 
    };

    return (
        <React.Fragment>
            <ReactApexChart options={options} series={series} type="line" height={280} />
        </React.Fragment>
    );
};

export { WebsiteAnalyticsChart };
